import { useRequest } from '@hourly/hooks/useRequest';
import { useState } from 'react';
import { Page } from '../../../../_shared/data/models/Page';
import { Customer } from '../models/customer.model';
import { getLiveCustomers } from '../requests/customers.request';

export function useLiveCustomers(partnerId: string) {
  const [customersPage, setCustomersPage] = useState<Page<Customer>>({
    items: [],
    search: '',
    totalItems: 0,
    current: 1,
  });

  const { request: fetchCustomersPage, status } = useRequest(
    async ({ page, search }: { page: number; search: string }) => {
      if (!partnerId) {
        return;
      }
      setCustomersPage(await getLiveCustomers(partnerId, { page, search }));
    },
    { requestOnMount: true, initialParams: { page: 1, search: '' } }
  );

  return {
    customersPage,
    fetchCustomersPage,
    isGetCustomersSettled: status.isError || status.isSuccess,
  };
}
